<template>
  <div id="login">
    <Navbar></Navbar>
    <div class="container">
      <h1>Login</h1>
      <input type="email" placeholder="Email" v-model="email" />
      <br />
      <input type="password" placeholder="Password" v-model="password" />
      <br />
      <button @click="login">Login</button>
      <p>
        Need an account?
        <router-link to="/signup">Sign Up</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Navbar from "../components/Navbar";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      random: [],
    };
  },
  methods: {
    login: function () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          (usr) => {
            console.log(usr);
            this.$router.push("/dashboard");
          },
          (err) => {
            alert("Error: " + err);
          }
        );
    },
  },
  components: {
    Navbar,
  },
};
</script>

<style lang="scss" scoped>
#login {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0cce6b;
}

.container {
  input {
    padding: 5px 5px;
    font-size: 1.1rem;
    margin: 15px 0;
    background: transparent;
    border: none;
    border-bottom: solid white;
    outline: none;
    color: white;
    width: 300px;
  }

  a {
    text-decoration: none;
    color: #ef2d56;
    font-weight: 600;
  }

  button {
    margin: 15px 0;
    padding: 10px 10px;
    width: 60%;
    border: none;
    outline: none;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 50px;
    transition: 0.15s;
    &:hover {
      cursor: pointer;
      color: #ffffff;
      background: #ef2d56;
    }
  }
}
</style>